import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  AlarmClockTabModel,
  AudioDedicationTabModel,
  DedicationTabModel,
  HtmlTabModel,
  LiveFeedTabModel,
  PodcastTabModel,
  RssTabModel,
  SongHistoryTabModel,
  TabType,
  WebsiteTabModel,
} from '../models/app-tabs.model';

@Injectable({
  providedIn: 'root',
})
export class MockTabsService {
  constructor(private readonly translate: TranslateService) {}

  mockTabs: {
    dedicaces: DedicationTabModel;
    rss: RssTabModel;
    rssPodcasts: RssTabModel;
    rssVideo: RssTabModel;
    rssNews: RssTabModel;
    site: WebsiteTabModel;
    html: HtmlTabModel;
    livefeed: LiveFeedTabModel;
    dedicacesaudio: AudioDedicationTabModel;
    reveil: AlarmClockTabModel;
    podcast: PodcastTabModel;
    ckoi: SongHistoryTabModel;
  } = {
    dedicaces: {
      idonglets: 0,
      type: TabType.Dedication,
      titre: this.translate.instant('mock-tabs.dedications'),
      icon: 'chat',
      faIcon: 'fa-solid fa-comments',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
    },
    rss: {
      idonglets: 0,
      type: TabType.Rss,
      titre: this.translate.instant('mock-tabs.rss'),
      icon: 'rss',
      faIcon: 'fa-solid fa-rss',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      urlFlux: this.translate.instant('mock-tabs.rss-link'),
      limit: '10',
    },
    rssPodcasts: {
      idonglets: 0,
      type: TabType.Rss,
      titre: this.translate.instant('mock-tabs.rss-podcasts'),
      icon: 'rss',
      faIcon: 'fa-solid fa-podcast',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      urlFlux: this.translate.instant('mock-tabs.podcast-link'),
      limit: '10',
    },
    rssVideo: {
      idonglets: 0,
      type: TabType.Rss,
      titre: this.translate.instant('mock-tabs.rss-video'),
      icon: 'rss',
      faIcon: 'fa-solid fa-video',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      urlFlux: this.translate.instant('mock-tabs.video-link'),
      limit: '10',
    },
    rssNews: {
      idonglets: 0,
      type: TabType.Rss,
      titre: this.translate.instant('mock-tabs.rss-news'),
      icon: 'rss',
      faIcon: 'fa-solid fa-newspaper',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      urlFlux: this.translate.instant('mock-tabs.rss-link'),
      limit: '10',
    },
    site: {
      idonglets: 0,
      type: TabType.Website,
      titre: this.translate.instant('mock-tabs.website'),
      icon: 'globe_black',
      faIcon: 'fa-solid fa-earth-europe',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      urlSite: 'https://www.google.com',
    },
    html: {
      idonglets: 0,
      type: TabType.Html,
      titre: 'Informations',
      icon: 'info',
      faIcon: 'fa-solid fa-circle-info',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      backgroundColor: '#ffffff',
      codeHTML: 'Hello World',
    },
    livefeed: {
      idonglets: 0,
      type: TabType.LiveFeed,
      titre: 'LiveFeed',
      faIcon: 'fa-solid fa-comment',
      icon: 'chat1',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
    },
    dedicacesaudio: {
      idonglets: 0,
      type: TabType.AudioDedication,
      titre: this.translate.instant('mock-tabs.shout-outs'),
      icon: 'quote2',
      faIcon: 'fa-solid fa-quote-right',
      headerColor: '#1E7FCB',
      headerTextColor: '#ffffff',
      idradio: -1,
      foregroundColor: '#ffffff',
      backgroundColor: '#1e80cb',
      welcomeMessage: '',
      endMessage: '',
    },
    reveil: {
      idonglets: 0,
      type: TabType.Alarm,
      titre: this.translate.instant('mock-tabs.alarm'),
      faIcon: 'fa-regular fa-clock',
      icon: 'time',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
    },
    podcast: {
      idonglets: 0,
      type: TabType.Podcast,
      titre: this.translate.instant('mock-tabs.podcast'),
      icon: 'podcast',
      faIcon: 'fa-solid fa-podcast',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
      podcastsRssList: [this.translate.instant('mock-tabs.podcast-link')],
      forceBackgroundColor: false,
      backgroundColor: '#252525'
    },
    ckoi: {
      idonglets: 0,
      type: TabType.SongHistory,
      titre: this.translate.instant('mock-tabs.song-history'),
      icon: 'calendar',
      faIcon: 'fa-solid fa-calendar',
      headerColor: '#000000',
      headerTextColor: '#ffffff',
    },
  };

  getTabs(): {
    dedicaces: DedicationTabModel;
    rss: RssTabModel;
    rssPodcasts: RssTabModel;
    rssVideo: RssTabModel;
    rssNews: RssTabModel;
    site: WebsiteTabModel;
    html: HtmlTabModel;
    livefeed: LiveFeedTabModel;
    dedicacesaudio: AudioDedicationTabModel;
    reveil: AlarmClockTabModel;
    podcast: PodcastTabModel;
    ckoi: SongHistoryTabModel;
  } {
    return this.mockTabs;
  }
}
